import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const MATERIAS_CONST = 'materias';
export const entCarMaterias = `${baseUrl}/entidad-carrera-materias`;

export const allMateriasService = async (params) => {
  const res = await axios.get(`${baseUrl}/${MATERIAS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveMateriasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${baseUrl}/${MATERIAS_CONST}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${baseUrl}/${MATERIAS_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneMateriasService = async (id) => {
  const res = await axios.get(`${baseUrl}/${MATERIAS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteMateriasService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${MATERIAS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const asignarEntCarMateriasService = async (data) => {
  const res = await axios.post(entCarMaterias, data, { headers: token({}) });
  return res;
};

export const deleteEntCarMateriasService = async (id) => {
  const res = await axios.delete(`${entCarMaterias}/${id}`, {
    headers: token({}),
  });
  return res;
};
